// extracted by mini-css-extract-plugin
export default {"genericCard":"Jr-z","inline":"Kr-z","mastercard":"Lr-z","discover":"Mr-z","visa":"Nr-z","amex":"Or-z","active":"Pr-z"};